export const ERROR_MESSAGES = {
  LOAD_EVENT_ERROR: 'Erro ao carregar dados do evento. Por favor, tente novamente.',
  CREATE_EVENT_ERROR: 'Erro ao cadastrar evento. Por favor, tente novamente.',
  UPDATE_EVENT_ERROR: 'Erro ao atualizar evento. Por favor, tente novamente.',
  UPLOAD_IMAGE_ERROR: 'Erro ao fazer upload da imagem. Por favor, tente novamente.',
  PREPARE_EVENT_ERROR: 'Erro ao preparar dados do evento. Por favor, verifique os campos e tente novamente.',
  BRANDS_REQUIRED: 'Selecione pelo menos uma marca em Brands.',
  UNKNOWN_ERROR: 'Erro desconhecido'
}

export const SUCCESS_MESSAGES = {
  CREATE_EVENT_SUCCESS: 'Evento cadastrado com sucesso!',
  UPDATE_EVENT_SUCCESS: 'Evento atualizado com sucesso!'
}

export const LOADING_MESSAGES = {
  LOADING_EVENT: 'Carregando dados do evento...'
}

export const REDIRECT_DELAY = 200
